import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckSquare, X, Zap } from 'lucide-react';
import { AgentList } from './components/voice-agents/AgentList';
import QuickCreateSheet from './components/voice-agents/QuickCreateSheet';

const VoiceAgentsPage = () => {
  const navigate = useNavigate();
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isSelectionMode, setIsSelectionMode] = useState(false);
  const [selectedAgentIds, setSelectedAgentIds] = useState<Set<string>>(new Set());
  const [isQuickCreateOpen, setIsQuickCreateOpen] = useState(false);

  const handleAgentClick = (agent: any) => {
    navigate(`/genie-hub/my-genies/${agent.id}`, { state: { genie: agent } });
  };

  const toggleSelectionMode = () => {
    setIsSelectionMode(!isSelectionMode);
    setSelectedAgentIds(new Set());
  };

  return (
    <div className="min-h-screen bg-[#F9FAFC]">
      <div className="container mx-auto max-w-[1920px] w-full px-4 py-5 md:py-6">
        {/*
          WorkspaceSwitcher is fixed at `right-6 top-5` (md and up) and owns the
          top-right corner, so the header actions have to stop short of it.
        */}
        <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between md:pr-[140px]">
          <div className="min-w-0">
            <h1 className="text-2xl sm:text-3xl font-bold text-[#222B45]">Voice Genies</h1>
            <p className="mt-1 text-sm text-gray-600">Every branded AI assistant on the platform</p>
          </div>
          <div className="flex shrink-0 flex-wrap items-center gap-2">
            <button
              type="button"
              onClick={toggleSelectionMode}
              aria-pressed={isSelectionMode}
              className="h-10 p-[2px] rounded-xl bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8] shadow-sm hover:shadow-md hover:shadow-genie-primary/25 transition-all"
            >
              <span
                className={`flex h-full items-center gap-2 rounded-[10px] px-3.5 text-sm font-semibold ${
                  isSelectionMode ? 'bg-gray-100 text-gray-700' : 'bg-white'
                }`}
              >
                {isSelectionMode ? (
                  <>
                    <X className="h-4 w-4" />
                    Cancel Selection
                  </>
                ) : (
                  <>
                    <CheckSquare className="h-4 w-4 text-genie-primary" />
                    <span className="bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8] bg-clip-text text-transparent">
                      Select Genies
                    </span>
                  </>
                )}
              </span>
            </button>
            <button
              type="button"
              onClick={() => setIsQuickCreateOpen(true)}
              className="h-10 flex items-center gap-2 rounded-xl bg-gradient-to-r from-genie-primary to-genie-secondary px-4 text-sm font-semibold text-white shadow-lg shadow-genie-primary/30 hover:from-genie-primary-hover hover:to-genie-secondary transition-all"
            >
              <Zap className="h-4 w-4" />
              Quick Create
            </button>
          </div>
        </div>

        <AgentList
          onAgentClick={handleAgentClick}
          refreshTrigger={refreshTrigger}
          isSelectionMode={isSelectionMode}
          selectedAgentIds={selectedAgentIds}
          onSelectionChange={setSelectedAgentIds}
        />
      </div>

      <QuickCreateSheet
        isOpen={isQuickCreateOpen}
        onClose={() => setIsQuickCreateOpen(false)}
        onSuccess={() => setRefreshTrigger((prev) => prev + 1)}
      />
    </div>
  );
};

export default VoiceAgentsPage;
